/** Inline, already-translated error message. Pass `message` from t()/apiErrorMessage(). */
export function ErrorBanner({ message }: { message: string }) {
  return (
    <div
      role="alert"
      className="rounded-md border border-danger bg-bg-subtle px-3 py-2 text-sm text-danger"
    >
      {message}
    </div>
  )
}
